// Example: BarbershopProvider.jsx
import { createContext, useEffect, useState, useContext } from "react";
import {
  getbarbershopConfig,
  getBarbershopSchedule,
} from "../api/barbershopApi";

export const BarbershopContext = createContext();

export const BarbershopProvider = ({ barbershopName, children }) => {
  const [config, setConfig] = useState(null);
  const [shopClosedDays, setShopClosedDay] = useState(null);
  const [shopScheduleSetting, setShopScheduleSetting] = useState(null);
  const [loadingConfig, setLoadingConfig] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        if (barbershopName) {
          const response = await getbarbershopConfig(barbershopName);
          setConfig(response);
          console.log(response);
        }
      } catch (error) {
        console.error("Failed to load barbershop config:", error);
      }
    };

    fetchConfig();
  }, [barbershopName]);

  useEffect(() => {
    const fetchSchedule = async () => {
      try {
        if (config) {
          const scheduleSetting = await getBarbershopSchedule(config.id);
          setShopScheduleSetting(
            scheduleSetting.weeklySchedule
              .filter((day) => day.isClosed)
              .map((day) => day.day),
          );
          setShopClosedDay(scheduleSetting.closedDays);
          setLoadingConfig(false);
        }
      } catch (error) {
        console.error("Failed to load barbershop schedule:", error);
      }
    };
    fetchSchedule();
  }, [config]);
  return (
    <BarbershopContext.Provider
      value={{ config, shopClosedDays, shopScheduleSetting, loadingConfig }}
    >
      {children}
    </BarbershopContext.Provider>
  );
};
export default BarbershopProvider;
